import { CircleAlert } from "lucide-react";
import React from "react";
import Button from "../../../../Button";
import { EMPTY_OBJ } from "../../../../helpers/logic/empties";
import Stack from "../../../../Stack";
import Typography from "../../../../Typography";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var defaultErrorString = "An error has occurred whilst loading this data.";

// eslint-disable-next-line import/prefer-default-export
export function ErrorState(_ref) {
  var size = _ref.size,
    errorButtonProps = _ref.errorButtonProps,
    _ref$errorMessage = _ref.errorMessage,
    errorMessage = _ref$errorMessage === void 0 ? defaultErrorString : _ref$errorMessage;
  var _ref2 = errorButtonProps || EMPTY_OBJ,
    onClick = _ref2.onClick,
    label = _ref2.label,
    isLoading = _ref2.isLoading;
  return /*#__PURE__*/_jsxs(Stack, {
    align: "center",
    direction: size === "compact" ? "horizontal" : "vertical",
    children: [/*#__PURE__*/_jsxs(Stack, {
      direction: "horizontal",
      align: "center",
      children: [/*#__PURE__*/_jsx(CircleAlert, {
        color: "var(--vitality-colors-critical11)"
      }), /*#__PURE__*/_jsx(Typography, {
        color: "critical",
        children: errorMessage
      })]
    }), errorButtonProps && onClick && /*#__PURE__*/_jsx(Button, {
      onClick: onClick,
      appearance: "primary",
      size: "compact",
      isLoading: isLoading,
      children: label || "Try again"
    })]
  });
}